import { coefficients } from "./coefficients";
import { getVolumeAreas } from "./index";

export const TABLE_MODEL_APPLICATION = {
  tableHead: ['', 'Demanda', 'Aplicado (kg)'],
  tableTitle: ['N (nitrogênio)', 'P2O5 (fósforo)', 'K2O (potássio)'],
  tableData: [
    ['0 kg', '0 Kg',],
    ['0 kg ', '0 Kg',],
    ['0 kg ', '0 Kg',],
  ]
};

export const TABLE_MODEL_OFFER = {
  tableHead: ['', 'Demanda (kg)', 'Oferta (kg)'],
  tableTitle: ['N (nitrogênio)', 'P2O5 (fósforo)', 'K2O (potássio)'],
  tableData: [
    ['0 kg', '0 Kg',],
    ['0 kg ', '0 Kg',],
    ['0 kg ', '0 Kg',],
  ]
};

export const getApplicationTable = (filteredAreas = [], totalAnnualVolume = 1, selectedYear) => {
  let nutrientsType = TABLE_MODEL_APPLICATION.tableTitle.map(title => title.split(" ")[0]);

  nutrientsType = nutrientsType.map(nutrient => {
    let [totalDemand, totalApplicated] = [0, 0];

    filteredAreas.length && filteredAreas.map(area => {
      const yearApplications = area?.applications ? area?.applications.filter(application => application?.applicationYear == selectedYear) : [];
      const totalVolumeApplied = getVolumeAreas(yearApplications);
      const demand = area.nutrientArea[nutrient]?.demand || 0;
      const offer = area.nutrientArea[nutrient]?.offer || 0;

      totalDemand += demand;
      totalApplicated += Math.round((totalVolumeApplied * offer) / totalAnnualVolume);
    });

    return {
      title: nutrient,
      totalDemand,
      totalApplicated
    }
  }) || [];

  return {
    ...TABLE_MODEL_APPLICATION,
    tableData: nutrientsType.map(item => [`${item?.totalDemand || 0} kg`, `${item?.totalApplicated || 0} kg`])
  }
}

export const getOfferTable = (filteredAreas = [], system = '', accommodation = 1) => {
  let nutrientsType = TABLE_MODEL_OFFER.tableTitle.map(title => title.split(" ")[0]);

  nutrientsType = nutrientsType.map(nutrient => {
    const nutrientCoefficient = coefficients[system] && coefficients[system][nutrient] || 0;
    let [totalDemand, totalApplicated] = [0,0];

    totalApplicated = nutrientCoefficient * accommodation;

    filteredAreas.length && filteredAreas.map(area => {
      const demand = area.nutrientArea[nutrient]?.demand || 0;
      totalDemand += demand;
    });

    return {
      title: nutrient,
      totalDemand: totalDemand.toFixed(0),
      totalApplicated: totalApplicated.toFixed(0)
    }
  }) || [];

  return {
    ...TABLE_MODEL_OFFER,
    tableData: nutrientsType.map(item => [`${item?.totalDemand || 0} kg`, `${item?.totalApplicated || 0} kg`])
  }
}